import React, { useEffect, useState } from "react";
import "./OffersPage.css";
import { useSelector, useDispatch } from "react-redux";
import { setOffers } from "../../../../../store/app/appReducer";
import callApi from "../../../../../utility/apiCaller";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { setUserClickData } from "../../../../../utility/setUserClickData";
import OfferCard from "./OfferCard";
import { TRACK_ID } from "../../../../../utility/enum";
import { useSearchParams } from "react-router-dom";
import _ from "lodash";
import { getAllianceLeadFromMoneyTapInput } from "../../../../../utility/commonUtils";
const OfferPage = ({ formData, setShowOfferHeaderLogo }) => {
  const lead = useSelector((state) => state.app.lead);
  const user = useSelector((state) => state.app.user);
  const offers = useSelector((state) => state.app.offers);
  const dispatch = useDispatch();
  const [isFinished, setIsFinished] = useState(false);
  const [leadId, setLeadId] = useState();
  const [expandedOfferId, setExpandedOfferId] = useState(null);
  const [activeLenders, setActiveLenders] = useState([]);
  const [params] = useSearchParams();
  const [isTncChecked, setIsTncChecked] = useState(true);
  const mobile = formData?.mobile || "";
  const navigate = useNavigate();
  const [source, setSource] = useState("");
  const token = user?.token;
  const leadFromStore = useSelector((state) => state?.app?.lead);
  const leadIdFromStore = leadFromStore?.id;

  let bucket2 = ["L&T", "IndusInd", "Tata Capital"];
  const lenderOrder = [
    "662752eb65fdba1a48d6e482",
    "687882db884a4422ccafa173", // IndusInd missing
    "67ef646df80610d286084e60",
    "662752eb65fdba1a48d6e464",
    "666ec1953a9a969d8f9980f1",
    "6855600d0313d8d083045d13",
    "662752eb65fdba1a48d6e474",
    "6851271c3a9753dd00d85475",
    "68b7cb3721c19b150d2893da", // Creditsea missing
  ];
  console.log(offers);
  const lenderNames = [
    "L&T",
    "IndusInd",
    "Hero",
    "MV",
    "Kissht",
    "Raam Fincorp",
    "TrueBalance",
    "Fatakpay",
    "Creditsea",
  ];
  const [ipAddress, setIpAddress] = useState("");

  const sortedOffers = [...offers].sort((a, b) => {
    const indexA = lenderOrder.indexOf(a.lender_id);
    const indexB = lenderOrder.indexOf(b.lender_id);

    // If lender_id is not in sequence, place it at the end
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });

  async function fetchIp() {
    await fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        // ipAddress = data?.ip;
        setIpAddress(data?.ip);
        console.log("IP Address:", data?.ip);
        console.log(ipAddress);
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }
  useEffect(() => {
    fetchIp();
  }, []);

  useEffect(() => {
    fetchActiveLenders();
  }, []);

  useEffect(() => {
    // if (formData.stepDone === 3 && !leadId) {
    submitLead();
    // }
  }, [formData]);

  useEffect(() => {
    if (offers.length > 0 && !expandedOfferId) {
      setExpandedOfferId(offers[0]._id);
    }
  }, [offers]);

  useEffect(() => {
    if (offers.length > 0) {
      setShowOfferHeaderLogo(false);
    }
  }, [offers]);

  const fetchActiveLenders = async () => {
    try {
      const res = await callApi(`v1/lender/active-lenders`, "get", {}, "loan");
      if (res.status === "Success") {
        const apiLenders = res.data.lenderList ?? [];

        // const hardcodedLender = {
        //   _id: "662752eb65fdba1a48d6e482",
        //   lender_name: "L&T",
        // };

        const mergedLenders = [...apiLenders];

        setActiveLenders(mergedLenders);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const submitLead = async () => {
    setUserClickData({
      event_name: "professional-details-submit-fb-lead-campaign",
      user_id: formData.mobile || "No User ID found here",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_source: params.get("utm_source") || params.get("utm_medium") || "",
    });
    try {
      const trackId = localStorage.getItem(TRACK_ID);
      const processedLead = getAllianceLeadFromMoneyTapInput(
        "website-pl-fb-lead",
        {
          ...formData,
          ...user,
        }
      );
      console.log("Processed Lead: ", processedLead);
      const res = await callApi(
        "v1/lead/bucket2_lead_push",
        "post",
        {
          lead_id: leadIdFromStore,
        },
        "core",
        user.token
      );

      console.log(res?.data?.lead);

      if (res.status === "Success" && res.data._id) {
        const newLeadId = res.data._id;
        const contactPhone = res.data.contact_phone;
        setLeadId(newLeadId);

        // Poller (recursive setTimeout) — no overlapping calls, deterministic stop
        const pollOffers = async (
          leadIdToPoll,
          attempt = 1,
          maxAttempts = 6
        ) => {
          if (!leadIdToPoll || isFinished) return;

          try {
            const found = await fetchOffers(leadIdToPoll);
            if (found) return; // success: fetchOffers sets isFinished(true) internally

            if (attempt < maxAttempts) {
              // schedule next attempt after 5s
              setTimeout(
                () => pollOffers(leadIdToPoll, attempt + 1, maxAttempts),
                5000
              );
              return;
            }

            // One final attempt after HDB push (or if HDB not applicable)
            const finalFound = await fetchOffers(leadIdToPoll);
            if (!finalFound) {
              // No offers found even after final attempt -> call bucket1_lead_push
              const bucket1Res = await callApi(
                "v1/lead/bucket1_lead_push",
                "post",
                {
                  lead_id: leadIdFromStore,
                },
                "core",
                user.token
              );

              if (bucket1Res.status === "Success" && bucket1Res.data._id) {
                const bucket1LeadId = bucket1Res.data._id;
                const pollBucket1Offers = async (
                  bucket1LeadIdToPoll,
                  attempt = 1,
                  maxAttempts = 4
                ) => {
                  if (!bucket1LeadIdToPoll || isFinished) return;

                  try {
                    const found = await fetchOffers(bucket1LeadIdToPoll);
                    if (found) return; // success: fetchOffers sets isFinished(true) internally

                    if (attempt < maxAttempts) {
                      // schedule next attempt after 5s
                      setTimeout(
                        () =>
                          pollBucket1Offers(
                            bucket1LeadIdToPoll,
                            attempt + 1,
                            maxAttempts
                          ),
                        2500
                      );
                      return;
                    }

                    // No offers found even after max attempts
                    setIsFinished(true);
                  } catch (err) {
                    console.error("Error while polling bucket1 offers", err);
                    setIsFinished(true);
                  }
                };

                // start polling for bucket1 offers
                pollBucket1Offers(bucket1LeadId, 1, 6);
                // await fetchOffers(bucket1LeadId);
              } else {
                setIsFinished(true);
              }
            }
          } catch (err) {
            console.error("Error while polling offers", err);
            setIsFinished(true);
          }
        };

        // start polling (first immediate attempt included inside pollOffers)
        pollOffers(newLeadId, 1, 6);
      }
    } catch (err) {
      toast("Some error occurred", { hideProgressBar: true, type: "error" });
      console.log(err);
    }
  };

  const fetchOffers = async (leadId) => {
    if (!leadId || isFinished) return false;
    try {
      const res = await callApi(
        `v1/loan_offer/lead_id/${leadId}`,
        "get",
        {},
        "core",
        user.token
      );

      if (res.status === "Success" && res.data?.offers?.length > 0) {
        console.log(res);
        const priorityRes = await callApi(
          `v1/finbud_data/finbud_update_priority/${leadId}`,
          "post",
          res,
          "loan",
          user.token
        );

        if (
          priorityRes.status === "Success" &&
          Array.isArray(priorityRes.data?.offers)
        ) {
          const sortedOffers = _.orderBy(
            priorityRes.data.offers,
            ["priority"],
            ["asc"]
          );

          const filteredOffers = activeLenders.length
            ? sortedOffers.filter((offer) =>
                activeLenders.some((lender) => lender._id === offer.lender_id)
              )
            : sortedOffers;
          const bucket2Offers = filteredOffers.filter((offer) =>
            bucket2.includes(offer.lender_name)
          );

          if (bucket2Offers.length > 0) {
            dispatch(setOffers(bucket2Offers));
          } else {
            dispatch(setOffers(filteredOffers));
          }
          //dispatch(setOffers(filteredOffers));

          if (priorityRes.data.lead?.all_responses) {
            setIsFinished(
              priorityRes.data.lead.all_responses ===
                priorityRes.data.lead.total_response
            );
          } else {
            setIsFinished(true);
          }
          return true;
        }
      }
      return false;
    } catch (err) {
      console.error("Error in offer fetching", err);
      toast.error("Something went wrong while fetching offers.");
      setIsFinished(true);
      return false;
    }
  };

  return (
    // <div id="offer-page-v5" >
    <div
      id={
        sortedOffers.some((offer) => bucket2.includes(offer.lender_name))
          ? "offer-page-v9-bucket2"
          : "offer-page-v9-bucket1"
      }
    >
      {offers.length > 0 ? (
        <>
          <div className="final-offers-container-v5">
            <>
              {/* <video
                className="background-video1"
                src="/assets/img/BG video.mp4"
                autoPlay
                loop
                muted
              /> */}
              <img
                src="/assets/img/Offer page BG image 1.png"
                alt="Square Check Background"
                className="background-overlay-img-offer"
              />
            </>
            <div className="offer-bg-layer-v5">
              <h2 className="congrats-text1">Congratulations!</h2>
              <h3 className="sub-text1">You’re Pre-Qualified for</h3>
              <h3 className="sub-text1">a Personal Loan!</h3>
            </div>
          </div>

          <div className="offer-cards-container-new1">
            {sortedOffers.map((offer) => (
              <OfferCard
                key={offer._id}
                offer={offer}
                isExpanded={expandedOfferId === offer._id}
                onExpand={() => setExpandedOfferId(offer._id)}
              />
            ))}
            <p className="disclaimer-offer-new-text-v5">
              Choose from these incredible offers that best suit your needs
            </p>
            <p className="disclaimer-text1">
              *These pre-approved offers are subject to change at discretion of
              Bank / NBFC after receiving all your documents and details. Final
              offer will be based on risk policy of Bank / NBFC. We do not
              guarantee that final offer will be same as Pre-approved offer.
            </p>
          </div>
        </>
      ) : isFinished ? (
        setShowOfferHeaderLogo(true) || (
          <div className="no-offers-found">
            <h2 className="congrats-text">
              There is no offer for you currently.
            </h2>
          </div>
        )
      ) : (
        setShowOfferHeaderLogo(true) || (
          <div className="no-offers-found">
            <h2 className="congrats-text">
              Please wait while we are searching best offers for you
            </h2>
          </div>
        )
      )}
    </div>
  );
};

export default OfferPage;
